<template>
    <div>
        <div class="modal fade" id="propertiesModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="propertiesModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form :model="fieldProperties">
                        <div class="modal-header">
                            <h5 class="modal-title">Modification composant</h5>
                        </div>
                        <div class="modal-body">
                            <ul class="nav nav-tabs ix-tabs" id="tabs" role="tablist">
                                <li class="nav-item ix-tab-item" v-if="formMode == 'summary'">
                                    <a class="ix-tab-link nav-link active" id="settings-tab" data-toggle="tab" href="#tab-settings" role="tab">Configuration</a>
                                </li>

                                <li class="nav-item ix-tab-item" v-show="activeForm.component == 'QuizzComponent'" v-for="(element,index) in activeForm.grid">
                                    <a class="ix-tab-link nav-link" :id="index + '-tab'" data-toggle="tab" :href="'#tab-' + index" role="tab">
                                        <span v-html="element.title ? truncate(element.title, 20) : 'Non renseignée'"></span> 
                                        <i class="far fa-times" v-show="activeForm.grid.length > 1" @click="removeRowGrid(index)"></i>
                                    </a>
                                </li>

                                <template  v-if="activeForm.component == 'ChartComponent' && activeForm.collections" >
                                    <li class="nav-item ix-tab-item" v-for="(element,index) in activeForm.collections.datasets">
                                        <a class="ix-tab-link nav-link" :id="index + 'chart-tab'" data-toggle="tab" :href="'#tab-chart-' + index" role="tab" v-bind:class="{'active' : formMode == 'fillable' && index == 0}">
                                            {{ element.label }} <i class="far fa-times" v-show="activeForm.collections.datasets.length > 1 && formMode == 'summary'" @click="removeChart(index)"></i>
                                        </a>
                                    </li>
                                </template>


                                <li class="nav-item ix-tab-item" v-show="activeForm.component == 'QuizzComponent'">
                                    <button class="ix-tab-link nav-link" role="tab" type="button" @click="addRowGrid">
                                        <i class="far fa-plus"></i>
                                    </button>
                                </li>

                                <li class="nav-item ix-tab-item" v-show="activeForm.component == 'ChartComponent' && formMode == 'summary'">
                                    <button class="ix-tab-link nav-link" role="tab" type="button" @click="addChart">
                                        <i class="far fa-plus"></i>
                                    </button>
                                </li>

                                <li class="nav-item ix-tab-item" v-show="activeForm.component == 'TableComponent'">
                                    <a class="ix-tab-link nav-link" id="array-tab" data-toggle="tab" href="#tab-array" role="tab">
                                        Titres des en-têtes
                                    </a>
                                </li> 
                            </ul>

                            <div class="tab-content">
                                <div class="tab-pane active" id="tab-settings" role="tabpanel">
                                    <!-- Label -->
                                    <div class="form-group" v-show="activeForm.hasOwnProperty('label') &&  this.formMode == 'summary'">
                                        <label for="label">Libellé</label>
                                        <input v-if="activeForm.component != 'ParagraphComponent'" type="text" class="form-control" v-model="activeForm.label">
                                        <textarea v-if="activeForm.component == 'ParagraphComponent'" rows="5" class="form-control" v-model="activeForm.label"/>
                                    </div>
                                    <!-- Texte d'aide -->
                                    <div class="form-group"  v-show="activeForm.type == 'data' && this.formMode == 'summary'">
                                        <label for="helper">Texte d'aide</label>
                                        <input type="text" class="form-control" v-model="activeForm.helper" id="helper">
                                    </div>                                         
                                    <!-- Required -->
                                    <div class="form-group" v-show="activeForm.hasOwnProperty('required')">
                                        <label for="required">Champs requis ?</label>
                                        <div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" id="not_required" value="false" v-model="activeForm.required" v-on:change="formatRadio('required')">
                                                <label class="form-check-label" for="not_required">Non</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" id="required" value="true" v-model="activeForm.required" v-on:change="formatRadio('required')">
                                                <label class="form-check-label" for="required">Oui</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Format champs texte -->
                                    <div class="form-group" v-show="activeForm.hasOwnProperty('inputType')">
                                        <label>Format</label>
                                        <select class="form-control" v-model="activeForm.inputType">
                                            <option value="text">Réponse courte</option>
                                            <option value="textarea">Paragraphe</option>
                                        </select>
                                    </div>
                                    <!-- Configuration de l'input number -->
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4">
                                            <div class="form-group" v-show="activeForm.hasOwnProperty('step')">
                                                <label>Intervalle</label>
                                                <input type="number" class="form-control" v-model="activeForm.step" placeholder="Eg. 0.1, 1, 5..">
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-4">
                                            <div class="form-group" v-show="activeForm.hasOwnProperty('min')">
                                            <label>Valeur minimale</label>
                                            <input type="number" class="form-control" v-model="activeForm.min" :step="activeForm.step">
                                        </div>
                                    
                                        </div>
                                        <div class="col-sm-12 col-md-4">
                                            <div class="form-group" v-show="activeForm.hasOwnProperty('max')">
                                                <label>Valeur maximale</label>
                                                <input type="number" class="form-control" v-model="activeForm.max" :step="activeForm.step">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Format datepicker -->
                                    <div class="form-group" v-show="activeForm.hasOwnProperty('format')">
                                        <label>Format</label>
                                        <select class="form-control" v-model="activeForm.format">
                                            <option value="date">JJ/MM/AAAA</option>
                                            <option value="datetime">JJ/MM/AAAA HH:MM</option>
                                            <option value="time">HH:MM</option>
                                        </select>
                                    </div>
                                    <!-- Image pdf -->
                                    <div class="form-group" v-show="activeForm.hasOwnProperty('show_pdf')">
                                        <label for="showPdf">Afficher les images dans le pdf ? </label>
                                        <div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" id="not_show_pdf" value="false" v-model="activeForm.show_pdf" v-on:change="activeForm.show_pdf = false">
                                                <label class="form-check-label" for="not_show_pdf">Non</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" id="show_pdf" value="true" v-model="activeForm.show_pdf" v-on:change="activeForm.show_pdf = true">
                                                <label class="form-check-label" for="show_pdf">Oui</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Type de graphique -->
                                    <div class="form-group" v-show="activeForm.component == 'ChartComponent' && this.formMode == 'summary'">
                                        <label for="property-chart-type">Type de graphique</label>
                                        <select class="form-control" v-model="activeForm.chartType" id="property-chart-type">
                                            <option value="Line">Courbe</option>
                                            <option value="Bar">Diagramme à barres</option>
                                            <option value="Pie">Diagramme circulaire</option>
                                        </select>
                                    </div>
                                    <!-- Options -->
                                    <div class="form-option" v-show="activeForm.hasOwnProperty('options')">
                                        <h2 class="ix-page-title-secondary mt-4">Options</h2>
                                        <div class="form-group">
                                            <draggable 
                                                :list="activeForm.options"
                                                class="elements"
                                                ghost-class="ghost"
                                                handle=".handle"
                                                :group="{name:'fields' , pull: 'clone' , put: false}">
                                                <div class="input-group mb-2" v-for="(item,index) in activeForm.options">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text">
                                                            <span class="ix-drag-icon handle"></span>
                                                        </span>
                                                    </div>
                                                    <input type="text" class="form-control" v-model="activeForm.options[index].value" placeholder="Saisir l'option">
                                                    <div class="input-group-append" v-show="activeForm.options.length > 1">
                                                        <button class="ix-btn ix-btn-icon transparent" type="button" @click="deleteOption(activeForm.options, index)"><i class="far fa-trash"></i></button>
                                                    </div>
                                                </div>
                                            </draggable>

                                            <button class="ix-btn link" @click="addOption(activeForm.options)" type="button"><i class="far fa-plus"></i> Ajouter une option</button>
                                        </div>
                                    </div>
                                    <!-- Tableau -->
                                    <div v-show="activeForm.hasOwnProperty('horizontal_labels') && activeForm.hasOwnProperty('vertical_labels') && activeForm.hasOwnProperty('rows')">
                                        <h2 class="ix-page-title-secondary mt-4">Paramètres du tableau</h2>
                                        <div class="form-group">
                                            <label>Position de l'en-tête</label>
                                            <select class="form-control" v-model="activeForm.position">
                                                <option value="horizontal">En-tête horizontale</option>
                                                <option value="vertical">En-tête verticale</option>
                                                <option value="both">En-tête horizontale et verticale</option>
                                            </select>
                                        </div>
                                      
                                        <div class="form-group">
                                            <label for="columns">Nombre de colonnes</label>
                                            <div class="input-group" v-if="activeForm.horizontal_labels">
                                                <div class="input-group-prepend">
                                                    <button class="ix-btn ix-btn-icon transparent" type="button" @click="removeColumn(activeForm.horizontal_labels)"><i class="far fa-minus"></i></button>
                                                </div>
                                                <!--  TODO :: remplacer retirer horizontal_label et travailler directement sur columns.length ?  ou au contraite utiliser vertical_label après ? -->
                                                <input type="number" class="form-control text-center" disabled v-model="activeForm.horizontal_labels.length" placeholder="Nombre de colonnes" min="1">
                                                <div class="input-group-append">
                                                    <button class="ix-btn ix-btn-icon transparent" type="button" @click="addColumn(activeForm.horizontal_labels, activeForm.rows)"><i class="far fa-plus"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="columns">Nombre de lignes</label>
                                            <div class="input-group" v-if="activeForm.rows">
                                                <div class="input-group-prepend">
                                                    <button class="ix-btn ix-btn-icon transparent" type="button" @click="removeRow(activeForm.rows)"><i class="far fa-minus"></i></button>
                                                </div>
                                                <input type="number" class="form-control text-center" disabled v-model="activeForm.vertical_labels.length" placeholder="Nombre de lignes" min="1">
                                                <div class="input-group-append">
                                                    <button class="ix-btn ix-btn-icon transparent" type="button" @click="addRow(activeForm.rows, activeForm.vertical_labels)"><i class="far fa-plus"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Questionnaire -->
                                    <div v-show="activeForm.component == 'QuizzComponent'">
                                        <div class="form-group">
                                            <label for="">Permettre la saisie d'observations</label>
                                            <div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" id="display_observation_false" value="false" v-model="activeForm.displayObservation" v-on:change="formatRadio('displayObservation')">
                                                    <label class="form-check-label" for="display_observation_false">Non</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" id="display_observation_true" value="true" v-model="activeForm.displayObservation" v-on:change="formatRadio('displayObservation')">
                                                    <label class="form-check-label" for="display_observation_true">Oui</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12">
                                                <h2 class="ix-page-title-secondary mt-4">Réponses proposées</h2>
                                                <div class="form-group">
                                                    <div class="input-group mb-2" v-show="activeForm.hasOwnProperty('labels')" v-for="(label,index) in activeForm.labels">
                                                        <input type="text" class="form-control" v-model="activeForm.labels[index]">
                                                        <div class="input-group-append">
                                                            <button class="ix-btn ix-btn-icon transparent" type="button" @click="removeGridColumn(index)" v-if="activeForm.labels.length > 1"><i class="far fa-trash"></i></button>
                                                        </div>
                                                    </div>

                                                    <button class="ix-btn link" @click="addGridColumn" type="button"><i class="far fa-plus"></i> Ajouter une réponse</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Graphique -->
                                    <h2 class="ix-page-title-secondary" v-if="activeForm.component == 'ChartComponent'">En-tête des séries</h2>
                                    <template v-if="activeForm.component == 'ChartComponent' && activeForm.collections && activeForm.collections.labels">
                                        <div class="form-group"  v-for="(label,i) in activeForm.collections.labels">
                                            <div class="input-group mb-2">
                                                <input type="text" class="form-control" v-model="activeForm.collections.labels[i]">
                                                <div class="input-group-append">
                                                    <button class="ix-btn ix-btn-icon transparent" type="button" @click="removeEntry(i)" v-if="activeForm.collections.labels.length > 1"><i class="far fa-trash"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <button class="ix-btn link" v-show="activeForm.component == 'ChartComponent'" type="button" @click="addEntry"><i class="far fa-plus"></i> Ajouter une entrée</button>   

                                    <!-- Envoie de document -->
                                    <div v-show="activeForm.component == 'AppendicesComponent'">
                                        <h2 class="ix-page-title-secondary">Ajouter une annexe</h2>
                                        <div class="form-group">
                                            <label for="file">Document</label>
                                            <div class="d-block">
                                                <input type="file" v-on:change="onFileChange" id="documentFile" ref="inputFile" accept="image/*,.pdf">
                                            </div>
                                            <span class="ix-text-secondary ix-text-small">Taille fichier maximale : 10 Mo</span>
                                        </div>
                                        <div class="form-group" v-show="selectedFile.hasOwnProperty('filename')">
                                            <label for="filename">Nom</label>
                                            <input type="text" class="form-control" v-model="selectedFile.filename" id="filename">
                                        </div>
                                
                                        <button class="ix-btn blue" v-on:click="submitFile" type="button" :disabled="loading">
                                            <span v-if="!loading">Ajouter le document</span>
                                            <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Envoi en cours</span>
                                        </button>
                                    </div>                                  
                                    <!-- Mise en forme -->
                                    <div v-show="activeForm.type == 'text' && activeForm.component != 'AppendicesComponent'">
                                        <div class="form-group" >
                                            <label for="font_size">Taille du label</label>
                                            <select class="form-control" v-model="activeForm.font_size">
                                                <option value="small">Petit</option>
                                                <option value="normal">Normal</option>
                                                <option value="large">Grand</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="font_size">Couleur du label</label>
                                            <input type="color" class="form-control" v-model="activeForm.font_color">
                                        </div>
                                        <div class="form-group">
                                            <label for="font_weight">Style du label</label>
                                            <select class="form-control" v-model="activeForm.font_weight">
                                                <option value="normal" style="{ font-style: normal}">Normal</option>
                                                <option value="bold" style="{ font-weight: bold}">Gras</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane" :id="'tab-' + index" role="tabpanel" v-show="activeForm.component == 'QuizzComponent'" v-for="(element,index) in activeForm.grid">
                                    <div v-show="activeForm.component == 'QuizzComponent'">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6">
                                                <div class="form-group">
                                                    <label for="title">Titre</label>
                                                    <input type="text" v-model="element.title" class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6">
                                                <div class="form-group">
                                                    <label for="background">Couleur de fond</label>
                                                    <input type="color" class="form-control" v-model="element.background" @change="getFontColorFromBackground(element)">
                                                </div>
                                            </div>

                                            <div class="col-sm-12">
                                                <h2 class="ix-page-title-secondary mt-4">Questions</h2>
                                                <div class="form-group">
                                                      <draggable 
                                                        :list="activeForm.grid[index].questions"
                                                        class="elements"
                                                        ghost-class="ghost"
                                                        handle=".handle-line"
                                                        :group="{name:'fields' , pull: 'clone' , put: false}">
                                                            <div class="input-group mb-2" v-for="(question,indexQuestion) in activeForm.grid[index].questions">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text">
                                                                        <span class="ix-drag-icon handle-line"></span>
                                                                    </span>
                                                                </div>
                                                                <input type="text" class="form-control" v-model="question.label">
                                                                <div class="input-group-append" v-if="activeForm.grid[index].questions.length > 1">
                                                                    <button class="ix-btn ix-btn-icon transparent" type="button" @click="removeQuestion(index,indexQuestion)"><i class="far fa-trash"></i></button>
                                                                </div>
                                                            </div>
                                                      </draggable>

                                                    <button class="ix-btn link" @click="addQuestion(index)" type="button"><i class="far fa-plus"></i> Ajouter une question</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane" id="tab-array" role="tabpanel" v-show="activeForm.component == 'TableComponent'">
                                    <div v-if="(activeForm.position == 'horizontal' || activeForm.position == 'both') &&  activeForm.horizontal_labels">
                                        <h2 class="ix-page-title-secondary">En-tête horizontale</h2>
                                        <div class="row" v-for="(element,index) in activeForm.horizontal_labels">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" v-model="activeForm.horizontal_labels[index]" placeholder="Saisir un titre">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="(activeForm.position == 'vertical' || activeForm.position == 'both') &&  activeForm.vertical_labels">
                                        <h2 class="ix-page-title-secondary">En-tête verticale</h2>
                                        <div class="form-group" v-for="(element,index) in activeForm.vertical_labels">
                                            <input type="text" class="form-control" v-model="activeForm.vertical_labels[index]" placeholder="Saisir un titre">
                                        </div>
                                    </div>
                                </div>

                                <!--
                                <div class="tab-pane" :id="'tab-file-' + index" role="tabpabel" v-show="activeForm.component == 'DocumentComponent'" v-for="(file,index) in activeForm.files">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label for="name">Nom</label>
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="activeForm.files[index].filename">
                                            </div>
                                        </div>
                                    </div>
                                     <div class="row">
                                        <div class="col-sm-12">
                                            <label for="color">Etiquette</label>
                                            <div class="form-group">
                                                <input type="color" class="form-control" v-model="activeForm.files[index].color">
                                            </div>
                                        </div>
                                    </div>
                                </div>-->

                                
                                <template v-if="activeForm.collections" v-show="activeForm.component == 'ChartComponent'">
                                    <div class="tab-pane" :id="'tab-chart-'+index" role="tabpanel" v-for="(data , index) in activeForm.collections.datasets" v-bind:class="{'active' : formMode == 'fillable' && index == 0}">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                   <label for="title_series">Titre de la série</label>
                                                   <input type="text" class="form-control" v-model="data.label">
                                               </div>
                                             

                                                <div class="form-group">
                                                    <label for="data_color">Couleur du graphique</label>
                                                    <input type="color" class="form-control" v-model="data.backgroundColor"/>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </template> 

                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="ix-btn green" @click="hideModal()"><i class="far fa-check"></i> Enregistrer</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import TableComponent from "./TableComponent";
    import draggable from 'vuedraggable';


    export default {
        name: "Properties",
        components: {TableComponent, draggable},
        store: ['activeForm' , 'activeModalFormBuilder', 'element', 'formMode'], // Get the form data from Home
        data(){
            return {
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                fieldProperties : {},
                rules: {},
                navIndex : 0,
                selectedFile: [],
                loading: false,
            }
        },
        mounted() {
        
        },
        methods: {
            hideModal(){
                $('#propertiesModal').modal('hide')
            },
            getFontColorFromBackground(el){
                if (el.background && el["color"] !== undefined) {
                    var hexcolor = el.background.replace("#", "");
                    var r = parseInt(hexcolor.substr(0,2),16);
                    var g = parseInt(hexcolor.substr(2,2),16);
                    var b = parseInt(hexcolor.substr(4,2),16);
                    var yiq = ((r*299)+(g*587)+(b*114))/1000;
                    el.color = (yiq >= 128) ? '#00000' : '#FFFFFF';
                }
            },
            formatRadio : function (properties) {
                this.activeForm[properties] = this.activeForm[properties] == 'true' ? true : false;
            },
            deleteOption(option, index){
                this.$delete(option, index)
            },
            onFileChange(e){
                 this.selectedFile = {
                    id: null,
                    filename: null,
                    file: null,
                    color : '#ffffff', 
                    files: []
                }
                var files = e.target.files
                if (!files.length)
                    return;

                this.selectedFile.file = files[0];
                 if (this.selectedFile.filename == "" || this.selectedFile.filename  == null) {
                    this.selectedFile.filename = files[0].name.split('.')[0]
                }   
            },
            submitFile(){
                this.loading = true;
                var data = new FormData()
                data.append('name', this.selectedFile.filename)
                data.append('file', this.selectedFile.file)
                data.append('color', this.selectedFile.color)

                fetch( '/api/upload', {
                     ...{
                        method : "POST"
                    },
                    ...this.getHttpJsonRequestHeaders(true),
                    ...{
                        body : data
                    }
                }).then((response) => {
                    this.loading = false;
                    if(response.ok) {
                        response.json().then(data => {
                             this.activeForm.files.push({
                                filename : data.name,
                                color : this.selectedFile.color,
                                path : data.path,
                                document_path : data.document_path,
                                extension : data.extension,
                                user_id : data.user_id,
                                id : data.id
                             })
                             this.selectedFile = {}
                            this.$refs.inputFile.value = null
                            this.hideModal();
                        })

                        
                        console.log(this.selectedFile)
                       
                    }
                }).catch((error) => {
                    this.loading = false;
                })
            },
            removeFile(file , index){
                this.loading = true;
                 this.$swal({
                    title : "Êtes vous sûr ?",
                    text : "Le fichier sera définitivement supprimé",
                    icon : "warning",
                    dangerMode : true,
                    buttons : ["Annuler" , "Supprimer"]
                }).then((willDo) => {
                    if(willDo){
                        fetch('/api/destroyFile?file_id='+file.id, {
                            ...{
                                method: 'DELETE'
                            },
                            ...this.getHttpJsonRequestHeaders(),
                        }).then(async (response) => {
                            if(response.ok)
                                this.activeForm.files.splice(index , 1);

                            this.loading = false

                        }).catch(error => {
                            this.loading = false
                            console.log(error);
                        })
                    }
                });
            },
            addOption(option){
                let count = option.length + 1;
                option.push({
                    value: "Option " + count
                })
            },
            addColumn(columns , rows){
                let countColumn = columns.length + 1;
                columns.push('');
                this.activeForm.columns_count++;
                rows.forEach((row,index) => {
                    row.push('');
                })
            },
            removeColumn(columns){
                if(columns.length > 1){
                    columns.splice(-1 , 1); // remove last index
                    this.activeForm.columns_count--;
                }
            },
            removeGridColumn(index){
                if(this.activeForm.labels.length > 0)
                    this.activeForm.labels.splice(index , 1);


                if(this.activeForm.grid && this.activeForm.labels.length > 0){
                    this.activeForm.grid.forEach((element,i) => {
                        element.questions.forEach(question => {
                            question.answers.splice(index,1)
                        });
                    })
                }

                this.activeForm.colspan = this.activeForm.colspan - 1;
            },
            removeQuestion(row , index){
                if(this.activeForm.grid[row].questions.length > 0)
                    this.activeForm.grid[row].questions.splice(index,1)
            },
            addQuestion(row, indexQuestion){
                let nameQuestion = 'Question ' + (this.activeForm.grid[row].questions.length + 1);
                if(indexQuestion != null){
                    if(this.activeForm.grid[row].questions.length - 1 == indexQuestion){
                        this.activeForm.grid[row].questions.push({'label' : nameQuestion , 'answers' : this.activeForm.labels , value: '', observations : ''})
                    }
                } else {
                    this.activeForm.grid[row].questions.push({'label' : nameQuestion , 'answers' : this.activeForm.labels , value: '', observations : ''})
                }
            },
            addGridColumn(){
                this.activeForm.labels.push('Nouvelle réponse')
                if(this.activeForm.grid ){
                    this.activeForm.grid.forEach((element,i) => {
                        element.questions.forEach(question => {
                            question.answers = this.activeForm.labels;
                        });
                    })
                }
                this.activeForm.colspan = this.activeForm.colspan + 1;
            },
            addRowGrid(){
                this.activeForm.grid.push({
                    title : 'Thématique',
                      questions : [{
                        label : 'Question 1',
                        answers : this.activeForm.labels,
                        value: '', 
                        observations : ''
                    }],
                    background: '#0f6674',
                    color: '#ffffff',
                    borderColor: '#0f6674',
                    textAlign: 'center'
                })
            },
            removeRowGrid(index){
                this.activeForm.grid.splice(index , 1);
            },
            addRow(rows, columns){
                this.activeForm.vertical_labels.push('');
                this.activeForm.rows_count++;
                rows.push(new Array(columns.length));
            },
            removeRow(rows){
                if(rows.length > 1){
                    rows.splice(-1 , 1);
                    this.activeForm.rows_count--;
                }
                if(this.activeForm.vertical_labels.length > 1){
                    this.activeForm.vertical_labels.splice(-1,1);
                }
            },
            changeTypeChart(type){
                this.activeForm.chartType = type
            },
            deleteChart(index){
                this.activeForm.collections.datasets.splice(index , 1)
            },
            addChart(){
                this.activeForm.collections.datasets.push({
                    label: 'Série ' + (this.activeForm.collections.datasets.length + 1),
                    backgroundColor: '#5dade2',
                    data: new Array(this.activeForm.collections.labels.length)
                })
            },
            removeChart(index){
                this.activeForm.collections.datasets.splice(index , 1);
            },
            addChartValue(value , index){
                this.activeForm.collections.datasets[index].data.push(value);
            },
            addEntry(){
                this.activeForm.collections.labels.push('Titre ' + (this.activeForm.collections.labels.length + 1));
                this.activeForm.collections.datasets.forEach((element,i) => {
                    element.data = new Array(this.activeForm.collections.labels.length)
                })
            }, 
            removeEntry(index){
                this.activeForm.collections.labels.splice(index , 1);
                  this.activeForm.collections.datasets.forEach((element,i) => {
                    element.data = new Array(this.activeForm.collections.labels.length)
                })
            }
        },
    }
</script>

<style scoped>

    button.ix-tab-link:focus{ outline: none; }

    .delete-option:hover {
        background: darkred;
        color: white;
        border-color: darkred;
    }

    .btn-add-option {
        border: 0px;
        background: white;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 600;
    }

    .vm--modal {
        overflow-y: scroll !important;
    }

    .button-minus {
        background: darkred;
        border-color: darkred;
        color: white;
    }

    .button-plus {
        background: darkgreen;
        border-color: darkgreen;
        color: white;
    }

    .chart-type {
        display: flex;
        justify-content: space-around;
    }

    .btn-chart-type {
        background: #eeeeee;
        border: none;
        border-radius: 10px;
        width: 20%;
        padding: 10px;
        font-size: 16px;
    }

    .nav-form {
        display: flex;
        align-items: center;
    }

    .active-form {
        color: #0f6674;
        border-bottom: 1px solid #0f6674;
    }

    .nav-form-title {
        padding: 10px;
    }

</style>
